import React from 'react'
import { func, object, array, string } from 'prop-types'
import {
  Form,
  TagsInputWrapper,
  SmallToMediumScreenOnly,
  LargeScreenUp,
  Grid
} from '../../utils/style'
import TagsInput from 'react-tagsinput'
import VehicleListingFilterAccordion from '../VehicleListingFilterAccordion'
import ShowResultsButton from './components/ShowResultsButton'
import IconClearFilters from './components/IconClearFilters'
import {
  KeywordSearch,
  KeywordSearchLabel,
  KeywordSearchInput
} from './components/KeywordSearch'
import { Label } from '@rebass/forms/styled-components'

import FilterOptions from './components/FilterOptions'
import CheckedFilters from './components/CheckedFilters'
import RangeInput from './components/RangeInput'
import PriceAccordion from './components/PriceAccordion'
import { ResultsPagingStats } from '../VehicleListingFilterBar'
import NumberFormat from 'react-number-format'

const defaults = {
  keywords: [],
  brand: ['Volkswagen', 'Skoda', 'Kia', 'Seat'],
  fuel: ['Diesel', 'Petrol', 'Electric', 'Hybrid']
}
const addKeys = [9, 13, 188] // Tab, Enter, Comma

const FilterAccordion = (props) => {
  if (!props.stats) return null
  return (
    <VehicleListingFilterAccordion
      selected={props.selected}
      key={`filter-options-${props.type}`}
      title={props.title}
      {...props}
    >
      <CheckedFilters onChange={props.onFilterChange} {...props} />
    </VehicleListingFilterAccordion>
  )
}
class VehicleListingFilterOptions extends React.Component {
  constructor(props) {
    super(props)
    this.defaults = defaults
    if (props.vehicleType === 'vans') this.defaults.brand = ['Volkswagen']
    this.onFilterChange = this.onFilterChange.bind(this)
    this.onClear = this.onClear.bind(this)
    this.onKeywordChange = this.onKeywordChange.bind(this)
    this.onSliderChange = this.onSliderChange.bind(this)
    this.onPriceChange = this.onPriceChange.bind(this)
  }

  onFilterChange(filterChange) {
    const newFilter = { ...this.props.filter, ...filterChange }
    const cleanFilter = Object.keys(newFilter).reduce((filter, key) => {
      if (Object.keys(newFilter[key]).length > 0) {
        filter[key] = newFilter[key]
      }
      return filter
    }, {})
    this.props.onChange(cleanFilter)
  }

  onClear(property) {
    let currentFilter = { ...this.props.filter }
    if (property) {
      if (property === 'brand') {
        currentFilter = {}
      } else {
        delete currentFilter[property]
      }
      this.props.onChange(currentFilter)
    } else {
      this.props.onChange({})
    }
  }

  onPriceChange(args) {
    if (args.monthlyPayment !== null)
      this.onSliderChange('monthlyPayment', { values: args.monthlyPayment })
    if (args.value !== null)
      this.onSliderChange('value', { values: args.value })
  }

  onSliderChange(filter, args) {
    const cleanFilter = {
      ...this.props.filter
    }
    if (['monthlyPayment', 'value'].includes(filter)) {
      delete cleanFilter.monthlyPayment
      delete cleanFilter.value
    }
    if (args.values) {
      cleanFilter[filter] = {
        min: args.values.min,
        max: args.values.max,
        fn: (value) => value >= args.values.min && value <= args.values.max
      }
    }
    this.props.onChange(cleanFilter)
  }

  onKeywordChange(keywords) {
    this.props.onChange({
      ...this.props.filter,
      keywords
    })
  }

  render() {
    return (
      <FilterOptions
        width={[10 / 12, 11 / 12, 4 / 12, 3 / 12]}
        order={1}
        className={this.props.hidden ? 'hidden' : 'visible'}
      >
        <ShowResultsButton width={[12 / 12]} py={[2, null, 11]} px={['3%']}>
          <SmallToMediumScreenOnly>
            {Object.keys(this.props.filter).length > 0 ? (
              <a
                onClick={(e) => {
                  e.preventDefault()
                  this.props.hideFilters(e, this)
                }}
              >
                Show Me Results <IconClearFilters />
              </a>
            ) : (
              <span>Filter used {this.props.vehicleType}</span>
            )}
          </SmallToMediumScreenOnly>
          <LargeScreenUp>
            {Object.keys(this.props.filter).length > 0 ? (
              <a
                onClick={(e) => {
                  e.preventDefault()
                  this.onClear()
                }}
              >
                Clear Filters <IconClearFilters />
              </a>
            ) : (
              <span>Filter used {this.props.vehicleType}</span>
            )}
          </LargeScreenUp>
        </ShowResultsButton>
        <SmallToMediumScreenOnly>
          <ResultsPagingStats
            width={[12 / 12, null, 6 / 12]}
            py={[2, null, 11]}
            px={['3%']}
          >
            Used {this.props.page.type}
            {this.props.page.total > 0 && (
              <span>
                <Grid px={['8px']}>|</Grid>
                Showing&nbsp;
                <NumberFormat
                  value={this.props.page.total}
                  displayType={'text'}
                  thousandSeparator
                />
                &nbsp;{this.props.page.type}
              </span>
            )}
          </ResultsPagingStats>
        </SmallToMediumScreenOnly>
        <Form>
          <Label width={1 / 1} py={20}>
            <KeywordSearch flexWrap="wrap">
              <KeywordSearchLabel width={[2 / 6, 1 / 6, 2 / 6, null]} pl={25}>
                Keyword
              </KeywordSearchLabel>
              <KeywordSearchInput
                width={[6 / 12, 9 / 12, 7 / 12, null]}
                ml={[null, null, null, 'auto']}
                pr={25}
              >
                <TagsInputWrapper>
                  <TagsInput
                    value={this.props.filter.keywords || this.defaults.keywords}
                    onChange={this.onKeywordChange}
                    inputProps={{ placeholder: 'Enter keyword' }}
                    addKeys={addKeys}
                    onlyUnique
                    aria-label="Filter by keyword"
                  />
                </TagsInputWrapper>
              </KeywordSearchInput>
            </KeywordSearch>
          </Label>
          <PriceAccordion
            onPriceChange={this.onPriceChange}
            hasMonthly={this.props.vehicleType !== 'vans'}
            prices={this.props.vehicles.reduce(
              (prices, vehicle) => {
                prices.value.push(vehicle.value)
                prices.monthlyPayment.push(vehicle.hpFinance.monthlyPayment)
                return prices
              },
              { value: [], monthlyPayment: [] }
            )}
            values={{
              value: this.props.filter.value,
              monthlyPayment: this.props.filter.monthlyPayment
            }}
          />
          <FilterAccordion
            title="Body Type"
            type="bodyStyle"
            onClear={() => this.onClear('bodyStyle')}
            defaults={this.defaults.bodyStyle}
            stats={this.props.counts.bodyStyle}
            selected={this.props.filter.bodyStyle}
            onFilterChange={this.onFilterChange}
            multiple
            hideZeroCount
            sorted
          />
          {Object.keys(this.props.counts.brand).length > 1 && (
            <FilterAccordion
              title="Brand"
              type="brand"
              onClear={() => this.onClear('brand')}
              defaults={this.defaults.brand}
              stats={this.props.counts.brand}
              selected={this.props.filter.brand}
              onFilterChange={this.onFilterChange}
            />
          )}
          <FilterAccordion
            title="Model"
            type="model"
            onClear={() => this.onClear('model')}
            stats={
              this.defaults.brand.length === 1 || this.props.filter.brand
                ? this.props.counts.model
                : {}
            }
            selected={this.props.filter.model}
            onFilterChange={this.onFilterChange}
            hideZeroCount
            sorted
            emptyMessage="Please select a Brand first"
            multiple
          />
          {Object.keys(this.props.counts.locationName).length > 1 && (
            <FilterAccordion
              title="Location"
              type="locationName"
              onClear={() => this.onClear('locationName')}
              defaults={this.defaults.locationName}
              stats={this.props.counts.locationName}
              selected={this.props.filter.locationName}
              onFilterChange={this.onFilterChange}
              sorted
            />
          )}

          <FilterAccordion
            title="Other"
            type="other"
            onClear={() => this.onClear('other')}
            defaults={this.defaults.other}
            stats={this.props.counts.other}
            selected={this.props.filter.other}
            onFilterChange={this.onFilterChange}
            sorted
            multiple
          />

          <FilterAccordion
            title="Age"
            type="year"
            onClear={() => this.onClear('year')}
            defaults={this.defaults.year}
            stats={this.props.counts.year}
            selected={this.props.filter.year}
            onFilterChange={this.onFilterChange}
            multiple
          />
          <VehicleListingFilterAccordion
            title="Mileage"
            selected={this.props.filter.mileage ? [true] : []}
            onClear={() => this.onClear('mileage')}
          >
            <fieldset>
              <RangeInput
                data={this.props.vehicles.map(({ mileage }) => mileage)}
                onChange={(args) => this.onSliderChange('mileage', args)}
                step={2000}
                values={this.props.filter.mileage}
              />
            </fieldset>
          </VehicleListingFilterAccordion>
          <FilterAccordion
            title="Fuel Type"
            type="fuel"
            onClear={() => this.onClear('fuel')}
            defaults={this.defaults.fuel}
            stats={this.props.counts.fuel}
            selected={this.props.filter.fuel}
            onFilterChange={this.onFilterChange}
            multiple
            hideZeroCount
          />
          <FilterAccordion
            title="Transmission"
            type="transmissionStyle"
            onClear={() => this.onClear('transmissionStyle')}
            defaults={this.defaults.transmissionStyle}
            stats={this.props.counts.transmissionStyle}
            selected={this.props.filter.transmissionStyle}
            onFilterChange={this.onFilterChange}
          />
          <VehicleListingFilterAccordion
            title="Engine Size (CC)"
            selected={this.props.filter.engineSize ? [true] : []}
            onClear={() => this.onClear('engineSize')}
            collapsed
          >
            <fieldset>
              <RangeInput
                data={this.props.vehicles.map(({ engineSize }) => +engineSize)}
                onChange={(args) => this.onSliderChange('engineSize', args)}
                step={100}
                values={this.props.filter.engineSize}
              />
            </fieldset>
          </VehicleListingFilterAccordion>
          <FilterAccordion
            title="Colour"
            type="colour"
            onClear={() => this.onClear('colour')}
            defaults={this.defaults.colour}
            stats={this.props.counts.colour}
            selected={this.props.filter.colour}
            onFilterChange={this.onFilterChange}
            collapsed
            hideZeroCount
            sorted
          />
          <FilterAccordion
            title="Seats"
            type="seats"
            onClear={() => this.onClear('seats')}
            defaults={this.defaults.seats}
            stats={this.props.counts.seats}
            selected={this.props.filter.seats}
            onFilterChange={this.onFilterChange}
            collapsed
            sorted
          />
          {this.props.vehicleType !== 'vans' && (
            <VehicleListingFilterAccordion
              title="Road Tax"
              selected={this.props.filter.engineSize ? [true] : []}
              onClear={() => this.onClear('engineSize')}
              collapsed
            >
              <fieldset>
                <RangeInput
                  data={this.props.vehicles.map(({ roadTax }) => +roadTax)}
                  onChange={(args) => this.onSliderChange('roadTax', args)}
                  step={5}
                  values={this.props.filter.roadTax}
                />
              </fieldset>
            </VehicleListingFilterAccordion>
          )}
          <VehicleListingFilterAccordion
            title="CO2"
            selected={this.props.filter.co2 ? [true] : []}
            onClear={() => this.onClear('co2')}
            collapsed
          >
            <fieldset>
              <RangeInput
                data={this.props.vehicles.map(({ co2 }) => +co2)}
                onChange={(args) => this.onSliderChange('co2', args)}
                step={10}
                values={this.props.filter.co2}
              />
            </fieldset>
          </VehicleListingFilterAccordion>
          <VehicleListingFilterAccordion
            title="MPG"
            selected={this.props.filter.mpg ? [true] : []}
            onClear={() => this.onClear('mpg')}
            collapsed
          >
            <fieldset>
              <RangeInput
                data={this.props.vehicles.map(({ mpg }) => +mpg)}
                onChange={(args) => this.onSliderChange('mpg', args)}
                step={5}
                values={this.props.filter.mpg}
              />
            </fieldset>
          </VehicleListingFilterAccordion>
          <VehicleListingFilterAccordion
            title="B.H.P"
            selected={this.props.filter.bhp ? [true] : []}
            onClear={() => this.onClear('bhp')}
            collapsed
          >
            <fieldset>
              <RangeInput
                data={this.props.vehicles.map(({ bhp }) => bhp)}
                onChange={(args) => this.onSliderChange('bhp', args)}
                step={10}
                values={this.props.filter.bhp}
              />
            </fieldset>
          </VehicleListingFilterAccordion>
          <FilterAccordion
            title="On Sale"
            type="onSale"
            onClear={() => this.onClear('onSale')}
            defaults={this.defaults.onSale}
            stats={this.props.counts.onSale}
            selected={this.props.filter.onSale}
            onFilterChange={this.onFilterChange}
            collapsed
            sorted
          />
        </Form>
      </FilterOptions>
    )
  }
}

VehicleListingFilterOptions.defaultProps = {
  vehicles: [],
  filter: {},
  vehicleType: 'cars'
}

VehicleListingFilterOptions.propTypes = {
  onChange: func,
  vehicles: array,
  filter: object,
  vehicleType: string
}

export default VehicleListingFilterOptions
